import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// "ResizeObserver loop completed with undelivered notifications" fires when an
// observed element resizes again within the same frame — e.g. React Flow's node
// measurement while dragging the /mlmate map/drawer separator. The notice is
// benign per spec, but CRA's dev overlay escalates any window error to a red
// screen (and its listener registers before app code, so it can't be swallowed
// here). Fix it at the source instead: deliver all ResizeObserver callbacks on
// the next animation frame, so the same-frame loop can never occur.
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class extends OriginalResizeObserver {
  constructor(callback: ResizeObserverCallback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => callback(entries, observer));
    });
  }
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
